import store from '@/store/store'
import { getsocketUrl } from "@/utils/index"
import { imgDownLoad } from "@/api/index"
import { Message } from 'element-ui'
import SpeakTts from 'speak-tts'
import audioService from './AudioService'
let socket = null
let heartCheckStart = null
let count2 = 0
let lockReconnect = false
let notifyInstance = null;
let socketInstanceId = 0;
const tts = new SpeakTts()
tts.init({ volume: 1, lang: "zh-CN", rate: 1, pitch: 1 }).catch(() => { })
const handlePrescriptionNotify = (text, presData) => {
    if (notifyInstance) {
        notifyInstance.close();
    }
    audioService.play();

    notifyInstance = Message({
        message: `<strong style="font-size: 18px;">${text}</strong>`,
        type: 'warning',
        duration: 0,
        showClose: true,
        center: true,
        offset: 100,
        dangerouslyUseHTMLString: true,
        onClose: () => { notifyInstance = null; }
    });
    store.commit("TRIGGER_PRE_REFRESH");
    const isPresPage = window.location.hash.includes('prescriptions');
    if (!isPresPage) {
        window.location.hash = '#/prescriptions';
        console.log("跳转成功");

    }
};

export const socketInit = () => {
    const token = localStorage.getItem("token");
    const doctorCode = localStorage.getItem("doctorEmployee");
    if (!token) {
        console.warn("未获取到 Token 或 DoctorCode，取消 Socket 连接");
        return;
    }
    if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;
        socket.close();
    }
    const currentInstanceId = ++socketInstanceId;
    const socketUrl = getsocketUrl()
    socket = new WebSocket(socketUrl)
    lockReconnect = false


    socket.onopen = () => {
        if (currentInstanceId !== socketInstanceId) return;
        const getLatestPostData = () => JSON.stringify({
            token: localStorage.getItem("token"),
            doctorCode: localStorage.getItem("doctorEmployee"),
        });
        setTimeout(() => {
            if (socket.readyState == 1) {
                const data = getLatestPostData();
                if (data.includes('"token":null')) {
                    console.error("发送前检测到 Token 为空，停止发送");
                    return;
                }
                socket.send(data);
                count2 = 0
                // 心跳
                if (heartCheckStart) clearInterval(heartCheckStart)
                heartCheckStart = setInterval(() => {
                    if (socket.readyState === 1) socket.send(getLatestPostData())
                }, 120000)
            }
        }, 1000)
    }

    socket.onmessage = (evt) => {
        if (currentInstanceId !== socketInstanceId) {
            console.warn("丢弃旧实例的消息");
            return;
        }
        const dataObj = JSON.parse(evt.data)
        const time = new Date().toLocaleString()

        if (dataObj.data) {
            if (dataObj.data.type == -1) {
                store.commit("UPDATE_ASIDE_FLAG")
            }
            else if (dataObj.code == 0) {
                let data = {
                    type: 0,
                    sendType: dataObj.data.sendType,
                    receiver: 2,
                    time: time,
                    contentData: dataObj.data.data,
                    contentType: dataObj.data.contentType,
                }

                if (dataObj.data.type == "3") {
                    if (dataObj.data.doctorCode == localStorage.getItem("doctorEmployee")) {
                        data.type = 3; data.sendType = 2; data.sender = "my"; data.receiver = "user";
                        data.contentData = JSON.parse(dataObj.data.data).message;
                        data.orderNumber = dataObj.data.orderNumber;
                    } else {
                        store.commit("REDUCE_ASIDE_FLAG")
                    }
                }
                if (dataObj.data.type == "4") {
                    store.commit("REDUCE_ASIDE_FLAG")
                    if (dataObj.data.orderNumber == store.state.orderNumber) {
                        store.commit("SET_SHOWMSGFLAG", false)
                        store.commit("SET_CF_FLAG", false)
                    }
                }
                if (dataObj.data.type == "5") {
                    data.type = 3; data.sendType = 2; data.sender = "my"; data.receiver = "user";
                    data.contentData = dataObj.data.data; data.orderNumber = dataObj.data.orderNumber;
                }
                if (dataObj.data.type == "6") {
                    data.type = 6; data.contentData = JSON.parse(dataObj.data.data);
                }
                if (dataObj.data.type == "9") {
                    store.commit("REDUCE_ASIDE_FLAG")
                    store.commit("SET_SHOWMSGFLAG", false)
                }
                if (dataObj.data.type == "10") { data.sendType = 2 }

                if (dataObj.data.type == "16") {
                    try {
                        const rawData = dataObj.data.data;
                        const presData = (typeof rawData === 'string' && rawData !== '') ? JSON.parse(rawData) : rawData;
                        const notifyText = "您有新的处方待审核，请及时处理！";
                        handlePrescriptionNotify(notifyText, presData);
                    } catch (err) {
                        console.error("处理16号消息失败:", err);
                        handlePrescriptionNotify("您有新的处方待审核，请及时处理！", {});
                    }
                    return;
                }

                if (store.state.orderNumber == dataObj.data.orderNumber && dataObj.data.type != "2" && dataObj.data.type != "9") {
                    if (dataObj.data.contentType == 1) {
                        imgDownLoad({ path: dataObj.data.data }).then((res) => {
                            data.imgUrl = "data:image/jpeg;base64," + res.data
                            data.sendType = 1
                            store.commit("SOCKET_updateChatMessageList", data)
                        })
                    } else {
                        store.commit("SOCKET_updateChatMessageList", data)
                    }
                }
            }
        }
    }

    socket.onerror = () => {
        if (currentInstanceId !== socketInstanceId) return;
        reconnect()
    }

    socket.onclose = () => {
        if (currentInstanceId !== socketInstanceId) return;
        reconnect()
    }
}

const reconnect = () => {
    if (lockReconnect) return
    lockReconnect = true
    if (heartCheckStart) clearInterval(heartCheckStart)

    if (count2 < 3) {
        setTimeout(() => {
            count2++
            socketInit()
            lockReconnect = false
        }, 15000)
    }
}

export const closeNotify = () => {
    if (notifyInstance) {
        notifyInstance.close();
        notifyInstance = null;
    }
};
export const closeSocket = () => {
    count2 = 100; 
    if (heartCheckStart) clearInterval(heartCheckStart);
    if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;
        socket.close();
        socket = null;
    }
};


export const sendSocketMsg = (msg) => {
    if (socket && socket.readyState === 1) socket.send(msg)
}